import React, { useContext, useState, useEffect, useRef } from 'react';
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  useTheme,
  useMediaQuery,
  Snackbar
} from '@mui/material';
import { generatePath } from '../../utils/categoryUtils/index.js';
import { PostsContext } from '../../contexts/PostsContext/index.jsx';
import {
  getSortedCategoriesbyLocation,
  getFeaturedPosts,
  sortPostsByTimestamp,
} from '../../utils/categoryUtils/index.js';
import { getSortedHomePageCategories } from '../../utils/categoryUtils/index.js';
import { useActiveComponent } from '../../Components/ActiveComponentContext.js/index.jsx';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext/index.jsx';
import { useLocation } from '../../contexts/LocationContext';
import IconButton from '@mui/material/IconButton';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import SearchBar from '../../Components/SearchBar/index.jsx';
import FixedHorizontalScrollBox from '../../Components/FixedHorizontalScrollBox/index.jsx';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const HomePage = () => {
  const [homeBannerImage, setHomeBannerImage] = useState(''); // State to store the image URL
  const placeholderImage = './images/siteImages/homeBanner1.jpg'; // Placeholder image for fallback
  const [isLoading, setIsLoading] = useState(false);
  const { currentUser, openLogInModal, setShowAlertDialog, } = useAuth(); // Use the AuthContext to get current user
  const { setActivePath, backgroundColor } = useActiveComponent();
  const navigate = useNavigate();
  //Retrieve data on all posts, filtered by category
  const { categoriesData } = useContext(PostsContext) || {};
  const [itemsToShow, setItemsToShow] = useState(3); // Start by showing 3 items
  const [currentSection, setCurrentSection] = useState(0);
  const carouselRef = useRef(null);
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg')); // Check if screen size is large or larger

//console.log("categories Data is ", JSON.stringify(categoriesData, null,2))

  const {
    userLocation,
    setUserLocation,
    detectCurrentLocation,
    updateUserLocation,
    checkLocationChange,
  } = useLocation();

  const [anchorElCreate, setAnchorElCreate] = useState(null);
  const sortedHomePageCategories = getSortedHomePageCategories(categoriesData);
  const featuredPosts = getFeaturedPosts(categoriesData);
  const sortedFeaturedPosts = sortPostsByTimestamp(featuredPosts); // Sort the posts, which is an array of objects with post info
  const structuredFeaturedPosts = [
    {
      category: 'Featured',
      posts: sortedFeaturedPosts, // Use the sorted posts
    },
  ];

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") return;
    setVerificationSnackbar((prev) => ({ ...prev, open: false }));
  };

  

  const categoriesToDisplay = sortedHomePageCategories; //not filtered by Country/city for now

  const handleLoadMore = () => {
    setItemsToShow((prev) => prev + 3); // Increase the number of items to show by 3
  };
  const handleCloseCreateMenu = () => {
    setAnchorElCreate(null);
  };

  const handleButtonItemClick = (item) => {
    const path = item.toLowerCase().replace(' ', ''); // Convert item to lowercase and remove spaces
    navigate(`/${path}`); // Navigate to the respective path
    setActivePath(`/${path}`);
  };

  //For Create Icon Button
  const handleCreateMenuItemClick = (item) => {
    if (currentUser) {
      const path = item.toLowerCase().replace(' ', ''); // Convert item to lowercase and remove spaces
      //handleNavigation(path); // Navigate to the corresponding path
      navigate(`/${path}`); // Navigate to the respective path
      setActivePath(`/${path}`);
    } else {
      setShowAlertDialog(true); // Show the alert dialog to login if the user is not signed in
    }
    handleCloseCreateMenu(); // Close the menu after clicking
    // setAnchorElCreate(null);//handled in handleCloseCreateMenu function
  };

  const isDEV = process.env.NODE_ENV === 'development';

  // console.log("structured posts:", categoriesToDisplay)

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <Box
      sx={{
        height: '100vh', // Full viewport height
        overflowY: 'auto', // Enable vertical scrolling of entire homepage
        pb: 2,
        top: 30,
        position: 'sticky',
        zIndex: 1000,
        backgroundColor: 'white',
      }}
    >
      <Box
        sx={{
          display: { xs: 'flex', sm: 'flex', lg: 'none', xl: 'none' },
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
          pb: 0.5,
          height: 45,
          ml: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
          position: 'sticky',
          top: 0,
          zIndex: 1000, // Ensure it's above other content while scrolling
        }}
      >
        <SearchBar width={300} />
      </Box>
      {/* Banner */}
      <Box
        component='img'
        // src={homeBannerImage || placeholderImage} // Use a placeholder if the image URL is not available
        src={placeholderImage}
        alt='Home Banner'
        sx={{
          overflowY: 'hidden',
          width: {
            xs: 330,
            sm: 330,
            md: 360,
            lg: 1200,
            xl: 1200,
          },
          height: 'auto',
          borderRadius: '14px',
          display: 'block',
          margin: 'auto',
          mt: 1,
          mb: 2,
        }}
      />

      {/* Removing featured section for now, build special UI for it and re-introduce in paid version */}
      {/* Change to isDEV later instead of !isDEV */}
      {isDEV &&
        structuredFeaturedPosts.map(({ category, posts }) => (
          <FixedHorizontalScrollBox
          // key={category}
            key={`${category}-${posts.title}`}
            data={posts}
            height='30px'
            category={category}
            categoryLength={posts.length}
            path={generatePath(category)} // Use the standardized path generation
          />
        ))}

      {/* Advertisement and link to Contact us to create Ad */}
      <Box
        sx={{
          backgroundColor: 'crimson',
          color: 'white',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '80%',
          height: '8vh',
          mr: 'auto',
          ml: 'auto',
          borderRadius: 6,
          gap: 3,
          pl: { xs: 2, sm: 2, md: 2 },
          pr: { xs: 2, sm: 2, md: 2 },
          mt: { lg: 6, xl: 6 },
          mb: { lg: 6, xl: 6 },
        }}
      >
        <Box
          component='img'
          src={'./images/siteImages/question.png'}
          alt='About Us Image-1'
          sx={{
            width: {
              xs: 40,
              sm: 40,
              md: 50,
              lg: 100,
              xl: 100,
            },
            '&:hover': {
              transform: 'scale(1.03)', // Optional: adds a slight zoom effect
              transition:
                'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
            },
          }}
        />
        <Typography sx={{ fontSize: { xs: 9, sm: 9, md: 11, lg: 14, xl: 14 } }}>
          Do you have a <b>Product</b> or <b>Service</b> you want to{' '}
          <b>Advertise</b> ?
        </Typography>
        <Button
          sx={{
            backgroundColor: '#0B399C',
            color: 'white',
            borderRadius: 8,
            fontSize: { xs: 8, sm: 8, md: 9, lg: 11, xl: 11 },
            pl: 1.5,
            pr: 1.5,
            '&:hover': {
              boxShadow: '0px 1px 3px blue',
              backgroundColor: 'white',
              color: '#0B399C',
            },
          }}
          onClick={() => handleButtonItemClick('Contact Us')} //make user contact us instead of creating their own post
        >
          Contact Us
        </Button>
      </Box>

      {categoriesToDisplay
        .slice(0, itemsToShow)
        .map(({ category, posts }, index) => (
          <React.Fragment key={category}>
            {posts && posts.length > 0 && (
              <FixedHorizontalScrollBox
                data={posts}
                height='40vh'
                category={category}
                path={generatePath(category)}
                categoryLength={posts.length}
              />
            )}
          </React.Fragment>
        ))}
      {/* Show Load More button if there are more items to display */}
      {itemsToShow < categoriesToDisplay.length && (
        <Box sx={{ textAlign: 'center', mt: 2, mb: 2 }}>
          <Button
            sx={{
              pl: 1,
              pr: 1,
              borderRadius: 5,
              color: 'darkblue',
              textTransform: 'none',
              '&:hover': {
                pl: 2,
                pr: 2,
                boxShadow: '0px -1px 2px inset lightgrey',
              },
            }}
            variant='text'
            onClick={handleLoadMore}
          >
            Load More
          </Button>
        </Box>
      )}
      {/* Disable Location Dialog for now for when we expand app to global audience & use paid API */}
      {/* <LocationDialog
        open={showLocationDialog}
        onClose={() => setShowLocationDialog(false)}
        location={newLocation}
        onAccept={handleLocationAccept}
        onKeepPrevious={handleKeepPrevious}
        isLocationChange={isLocationChange}
      /> */}
    </Box>
  );
};

export default HomePage;

//Advertisement sections:

// Add these states at the top of your component
// const [currentImages, setCurrentImages] = useState({});
// const handleScroll = (direction) => {
//   if (carouselRef.current) {
//     const scrollAmount = carouselRef.current.offsetWidth;
//     carouselRef.current.scrollBy({
//       left: direction === 'right' ? scrollAmount : -scrollAmount,
//       behavior: 'smooth',
//     });
//   }
// };

// useEffect(() => {
//   // Filter out expired ads
//   const activeAds = adPostsData?.filter((ad) => {
//     const expiryDate = new Date(ad.expiresAt.seconds * 1000);
//     return expiryDate > new Date();
//   });
//   // If you need the active ads stored for further use, set them once
//   //setActiveAds(activeAds); // Assuming you have a state for this
//   // Optionally, if you want to initialize the images for active ads:
//   const initialImages = {};
//   activeAds.forEach((ad) => {
//     initialImages[ad.id] = 0; // Start with the first image
//   });
//   setCurrentImages(initialImages); // Initialize image state for ads if required
//   console.log(
//     'my categories data is ',
//     JSON.stringify(categoriesData, null, 2)
//   );
//   // Cleanup: Remove the interval code to stop unnecessary re-renders
// }, [adPostsData]); // Only runs when `adPostsData` changes

// // Calculate active ads sections (groups of 2 or 3 based on screen size)
// const activeAds = adPostsData.filter((ad) => {
//   const expiryDate = new Date(ad.expiresAt.seconds * 1000);
//   return expiryDate > new Date();
// });

// // Determine the number of ads per section based on screen size
// const adsPerSection = isLgUp ? 3 : 2; // 3 for medium and larger screens, 2 for smaller screens

// const adSections = [];
// // for (let i = 0; i < activeAds.length; i += 3) {
// //   adSections.push(activeAds.slice(i, i + 3));
// // }
// for (let i = 0; i < activeAds.length; i += adsPerSection) {
//   adSections.push(activeAds.slice(i, i + adsPerSection));
// }

// FOR HANDLING USER LOCATION- USE WHEN OPENCAGE API IS PAID AND APP HAS EXPANDED GLOBAL

//used for location stuff when opencage is working
// const [showLocationDialog, setShowLocationDialog] = useState(false);
// const [newLocation, setNewLocation] = useState(null);
// const [isLocationChange, setIsLocationChange] = useState(false);
// const [locationChecked, setLocationChecked] = useState(false);
// const [isLocationFetched, setIsLocationFetched] = useState(false);

//TO IMPLEMENT LATER:
//Location Change Handling: If the user changes their location (either through the dropdown or geoLocator), ensure that the app updates the displayed categories accordingly.
//Error Handling: Implement error handling for cases where the geolocation API fails or returns an unexpected result. This will improve the robustness of your application.
// const currentSelectedCountry =
//   selectedCountry?.label || userLocation?.country || 'Ecuador'; // Default to 'Ecuador' if no location is available

// Sort categoriesData by Country, into most recent posts using getSortedCategories below
// const sortedCategoriesbyLocation = getSortedCategoriesbyLocation(
//   categoriesData,
//   currentSelectedCountry //select country from dropdown or GeoLocation API
//   currentSelectedCity //select city from dropdown or GeoLocation API
// );

// const categoriesToDisplay = (selectedCountry || userLocation?.country)
//   ? sortedCategoriesbyLocation
//   : sortedHomePageCategories;

//used to filter content by countries
// const categoriesToDisplay =
//   (selectedCountry && selectedCountry.label) || userLocation?.country
//     ? sortedCategoriesbyCountry
//     : sortedHomePageCategories;

// useEffect(() => {
//   const fetchUserLocation = async () => {
//     if (currentUser && !userLocation) {
//       try {
//         const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
//         if (userDoc.exists()) {
//           const storedLocation = userDoc.data().location;
//           setUserLocation(storedLocation); // Restore location from Firestore
//           console.log('Fetched User Location:', storedLocation);
//           //setIsLocationFetched(true); // Set the flag to true after fetching
//         } else {
//           console.warn('No location data found for the user.');
//         }
//       } catch (error) {
//         console.error('Error fetching user location:', error);
//       } finally {
//         setIsLocationFetched(true); // Set the flag to true after attempting to fetch
//       }
//     }
//   };

//   fetchUserLocation();
// }, [currentUser, userLocation]);

// useEffect(() => {
//   const checkUserLocation = async () => {
//     if (currentUser && (isLocationFetched || userLocation === null)) {
//       // Check if location has been fetched
//       try {
//         const currentLocation = await detectCurrentLocation();
//         const hasLocationChanged = await checkLocationChange(
//           currentLocation,
//           userLocation
//         );

//         // console.log("current location is - " + JSON.stringify(currentLocation, null, 2));
//         // console.log("user location is - " + JSON.stringify(userLocation, null, 2));
//         // console.log('Has location changed:', hasLocationChanged);
//         if (hasLocationChanged) {
//           setNewLocation(currentLocation);
//           setShowLocationDialog(true);
//         }
//       } catch (error) {
//         console.error('Error checking location:', error);
//       } finally {
//         setLocationChecked(true);
//       }
//     }
//   };

//   checkUserLocation();
// }, [
//   currentUser,
//   isLocationFetched,
//   userLocation,
//   detectCurrentLocation,
//   checkLocationChange,
// ]);

// const handleLocationAccept = async () => {
//   if (newLocation) {
//     await updateUserLocation(newLocation);
//   }
//   setShowLocationDialog(false);
// };

// const handleKeepPrevious = () => {
//   setShowLocationDialog(false);
// };

//   //oneUseEffect to replace the two above for user location -trying it:
//   useEffect(() => {
//     const handleUserLocation = async () => {
//         if (currentUser) {
//             try {
//                 // Fetch user location from Firestore
//                 const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
//                 let storedLocation = null;

//                 if (userDoc.exists()) {
//                     storedLocation = userDoc.data().location;
//                     setUserLocation(storedLocation); // Restore location from Firestore
//                     console.log("Fetched User Location:", storedLocation);
//                 }

//                 // Check current location
//                 const currentLocation = await detectCurrentLocation();
//                 const hasLocationChanged = await checkLocationChange(currentLocation, storedLocation);

//                 console.log("current location is - " + JSON.stringify(currentLocation, null, 2));
//                 console.log("user location is - " + JSON.stringify(storedLocation, null, 2));
//                 console.log('Has location changed:', hasLocationChanged);

//                 if (hasLocationChanged) {
//                     setNewLocation(currentLocation);
//                     setShowLocationDialog(true);
//                 }

//             } catch (error) {
//                 console.error('Error handling user location:', error);
//             } finally {
//                 setLocationChecked(true);
//             }
//         }
//     };

//     handleUserLocation();
// }, [currentUser, detectCurrentLocation, checkLocationChange]);

//was using it to fetch the top banner image:
// useEffect(() => {
//   const fetchImage = async () => {
//     const storage = getStorage(); // Initialize Firebase Storage
//     const imageRef = ref(storage, 'siteImages/homeBanner1.png'); // Reference to the image in Firebase

//     try {
//       const url = await getDownloadURL(imageRef); // Get the image URL
//       setHomeBannerImage(url); // Update the state with the URL
//       setIsLoading(false); // Stop loading once all images are fetched
//     } catch (error) {
//       console.error('Error fetching home banner image:', error); // Handle errors
//       setHomeBannerImage(placeholderImage); // Set fallback image in case of error
//       setIsLoading(false); // Stop loading once all images are fetched
//     }
//   };

//   fetchImage();
// }, []);

// Add section
// {adSections.length > 0 && (
//   <Box
//     sx={{
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       mt: 2,
//     }}
//   >
//     <AdsClickIcon
//       sx={{ fontSize: { xs: 18, sm: 18, md: 18, lg: 20, xl: 20 } }}
//     />
//     <Typography
//       variant='h2'
//       noWrap
//       component='div'
//       sx={{
//         padding: '7px',
//         borderRadius: '8px',
//         display: 'flex',
//         fontFamily: 'Montserrat',
//         fontWeight: 300,
//         textShadow: '0px 0px 0.7px black',
//         letterSpacing: '.3rem',
//         fontSize: { xs: 12, sm: 12, md: 13, lg: 15, xl: 15 },
//         color: '#030202',
//         textDecoration: 'none',
//       }}
//     >
//       Sponsored
//     </Typography>
//   </Box>
// )}

// {/* Only show the banner image if there are no active ads */}
// {adSections.length === 0 && (
//   <Box
//     component='img'
//     // src={homeBannerImage || placeholderImage} // Use a placeholder if the image URL is not available
//     src={placeholderImage}
//     alt='Home Banner'
//     sx={{
//       overflowY: 'hidden',
//       width: {
//         xs: 330,
//         sm: 330,
//         md: 360,
//         lg: 1200,
//         xl: 1200,
//       },
//       height: 'auto',
//       borderRadius: '14px',
//       display: 'block',
//       margin: 'auto',
//       mt: 1,
//       mb: 2,
//     }}
//   />
// )}

// {/* Render ads sections only if there are ads */}
// {adSections.length > 0 && (
//   <Box
//     sx={{
//       position: 'relative',
//       width: {
//         xs: 330,
//         sm: 330,
//         md: 360,
//         lg: 1200,
//         xl: 1200,
//       },
//       margin: 'auto',
//       mt: 1,
//       mb: 2,
//       overflowY: 'hidden',
//     }}
//   >
//     {/* Left Arrow */}
//     {adSections.length > 1 && (
//       <IconButton
//         onClick={() => handleScroll('left')}
//         sx={{
//           position: 'absolute',
//           left: 10,
//           top: '50%',
//           transform: 'translateY(-50%)',
//           zIndex: 2,
//           p: { xs: 0.5 },
//           backgroundColor: 'rgba(235,235,235,0.8)',
//           '&:hover': {
//             color: 'white',
//             backgroundColor: 'rgba(0,0,0,0.9)',
//           },
//         }}
//       >
//         <KeyboardArrowLeftIcon
//           sx={{ fontSize: { xs: 12, sm: 12, lg: 18, xl: 18 } }}
//         />
//       </IconButton>
//     )}

//     {/* Right Arrow */}
//     {adSections.length > 1 && (
//       //isLgUp &&
//       <IconButton
//         onClick={() => handleScroll('right')}
//         sx={{
//           position: 'absolute',
//           right: 10,
//           top: '50%',
//           transform: 'translateY(-50%)',
//           zIndex: 2,
//           p: { xs: 0.5 },
//           backgroundColor: 'rgba(235,235,235,0.8)',
//           '&:hover': {
//             color: 'white',
//             backgroundColor: 'rgba(0,0,0,0.9)',
//           },
//         }}
//       >
//         <KeyboardArrowRightIcon
//           sx={{ fontSize: { xs: 12, sm: 12, lg: 18, xl: 18 } }}
//         />
//       </IconButton>
//     )}

//     {/* Carousel Container */}
//     <Box
//       ref={carouselRef}
//       sx={{
//         display: 'flex',
//         height: {
//           xs: '150px',
//           sm: '150px',
//           md: '150px',
//           lg: '260px',
//           xl: '260px',
//         },
//         overflowX: 'auto',
//         scrollSnapType: 'x mandatory',
//         '&::-webkit-scrollbar': { display: 'none' },
//         scrollbarWidth: 'none',
//         p: 0,
//         overflowY: 'hidden',
//       }}
//     >
//       {/* Ad Sections - Only render if there are ads */}
//       {adSections.map((section, index) => (
//         <Box
//           key={index}
//           sx={{
//             display: 'flex',
//             gap: 1,
//             paddingTop: 0,
//             paddingBottom: 0,
//             borderRadius: 4,
//             justifyContent: 'center',
//             alignItems: 'center',
//             flex: '0 0 100%',
//             scrollSnapAlign: 'start',
//             boxSizing: 'border-box',
//             //border:'2px solid green',
//             overflowY: 'hidden',
//             width: { xs: '50%' },
//           }}
//         >
//           {section.map((ad, idx) => (
//             <Box
//               key={ad.id}
//               onClick={() => window.open(ad.relatedLink, '_blank')}
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 borderRadius: '20px',
//                 ml: 1.5,
//                 mr: 1.5,
//                 p: 0.5,
//                 flex: 1,
//                 height: '96%',
//                 width: `${100 / section.length}%`, // Dynamically distribute width
//                 overflow: 'hidden',
//                 position: 'relative',
//                 cursor: 'pointer',
//                 transition:
//                   'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
//                 '&:hover': {
//                   transform: 'scale(1.02)',
//                 },
//               }}
//             >
//               <img
//                 src={ad.images[0]}
//                 alt={ad.title}
//                 style={{
//                   width: isLgUp ? '300px' : '130px',
//                   height: '100%',
//                   objectFit: 'cover',
//                   borderRadius: '28px',
//                   backgroundColor: 'white',
//                 }}
//                 onError={(e) =>
//                   console.error(`Error loading image for ad ${ad.id}:`, e)
//                 }
//               />
//             </Box>
//           ))}
//         </Box>
//       ))}
//     </Box>
//   </Box>
// )}
